import React, { Component } from 'react';
import { Button } from 'carbon-components-react';
import { Route } from 'react-router-dom';
import { Breadcrumb, Tabs } from '../../../components';
import List from './List/List';

class MessageCampaignsModels extends Component {
 
  componentWillMount() {

  }



  render() {
  
    const { match, history } = this.props;
    const urlVisited = window.location.href;
    const vls = urlVisited.split('/');
    const sac = vls.includes('sac');
    return (
      <div>
        <Breadcrumb
          title="Cadastro de Modelos"
          description="Crie ou Gerencie Modelos."
        />
        <section className="content-wrapper">
          <Tabs
            sections={[
              { title: 'Mensagens', path: `${match.url}/mensagem` },
              { title: 'SAC', path: `${match.url}/sac` }
            ]}
          />
          <Route
            path={`${match.url}/mensagem`}
            component={() => <List {...this.props} type="1" />}
          />
          <Route
            path={`${match.url}/sac`}
            component={() => <List {...this.props} type="2" />}
          />

          <div className="v-md-margin">
            <div className="bx--col-xs-12 bx--col-sm-12 v-sm-margin">
              <Button
                className="bx--btn--full-width"
                onClick={() =>
                  history.push(
                    `/admin/modelos-mensagem/criar/${sac ? 'sac' : 'mensagem'}`
                  )
                }
              >
                Criar Modelo
              </Button>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default MessageCampaignsModels;



// WEBPACK FOOTER //
// ./src/screens/admin/MessageModels/MessageCampaingsModels.js